export default __webpack_public_path__ + "static/media/img-0008.9a8cb11f.png";